<template>
  <section class="d-flex flex-column justify-start align-center">
    <v-card flat max-width="616">
      <v-container fluid class="pa-0">
        <v-row>
          <v-col cols="12" class="d-flex justify-space-between align-center">
            <h4 class="text-subtitle-1 font-weight-bold text--primary">
              Descripción
            </h4>
            <v-chip :color="budgetStatusChipColor" dark>{{
              currentBudget.status_budget.name
            }}</v-chip>
          </v-col>
          <v-col cols="12">
            <v-textarea
              v-model="currentBudget.description"
              :readonly="editBudgetDisabled"
              @change="saveBudget"
              :error="$v.currentBudget.description.$error"
              @input="$v.currentBudget.description.$touch()"
              :error-messages="descriptionErrors"
              :autofocus="isNewBudget"
              auto-grow
              rows="1"
              class="pa-0 ma-0"
              hide-details="auto"
            ></v-textarea>
          </v-col>

          <v-col cols="12" class="d-flex justify-space-between align-center">
            <h4 class="text-subtitle-1 font-weight-bold text--primary">
              {{ isVisitBudget ? "Tareas" : "Mano de obra" }}
            </h4>
            <span>{{ formatCurrency(manpowerTotalAmount) }}</span>
          </v-col>

          <v-col cols="12" v-if="currentBudget.items_manpower.length > 0">
            <v-row
              v-for="(item, i) in currentBudget.items_manpower"
              :key="i"
              @click="showBudgetItemDialog('manpower', item, i)"
              class="flex-wrap justify-space-between align-center"
              dense
            >
              <v-col cols="8">
                <p class="mb-0">{{ item.description }} (x{{ item.cant }})</p>
              </v-col>
              <v-col cols="auto">
                <p class="mb-0">{{ formatCurrency(item.amount) }}</p>
              </v-col>
            </v-row>
          </v-col>

          <template v-if="!isVisitBudget">
            <v-col cols="12" class="d-flex justify-center">
              <v-btn
                text
                color="rapired"
                @click="showBudgetItemDialog('manpower', null, null)"
                :disabled="addItemsDisabled"
              >
                + AGREGAR ITEM MANO DE OBRA
              </v-btn>
            </v-col>
          </template>

          <template v-if="!isVisitBudget">
            <v-col cols="12" class="d-flex justify-space-between align-center">
              <h4 class="text-subtitle-1 font-weight-bold text--primary">
                Insumos
              </h4>
              <span>{{ formatCurrency(suppliesTotalAmount) }}</span>
            </v-col>
            <v-col cols="12" v-if="currentBudget.items_supplies.length > 0">
              <v-row
                v-for="(item, i) in currentBudget.items_supplies"
                :key="i"
                @click="showBudgetItemDialog('supplies', item, i)"
                class="flex-wrap justify-space-between align-center"
                dense
              >
                <v-col cols="8">
                  <p class="ma-0">{{ item.description }} (x{{ item.cant }})</p>
                </v-col>
                <v-col cols="auto">
                  <p class="ma-0">{{ formatCurrency(item.amount) }}</p>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="d-flex justify-center">
              <v-btn
                text
                color="rapired"
                @click="showBudgetItemDialog('supplies', null, null)"
                :disabled="addItemsDisabled"
              >
                + AGREGAR ITEM INSUMOS
              </v-btn>
            </v-col>
          </template>

          <v-col cols="12" class="d-flex justify-space-between align-center">
            <h4 class="text-subtitle-1 font-weight-bold text--primary">
              Total
            </h4>
            <span>{{ formatCurrency(budgetTotalAmount) }}</span>
          </v-col>

          <v-col
            cols="12"
            v-if="!editBudgetDisabled && !isVisitBudget"
            class="d-flex justify-center"
          >
            <v-btn
              :disabled="requestApprovalDisabled"
              color="secondary"
              @click="requestApproval"
              >SOLICITAR APROBACIÓN</v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-card>
    <BudgetItemDialog
      v-if="budgetItemDialog"
      :show="budgetItemDialog"
      :item="selectedItem"
      :type="selectedItemType"
      @save-item="saveItem($event)"
      @delete-item="deleteItem()"
      @close-dialog="budgetItemDialog = false"
    />
  </section>
</template>
<script>
import moment from "moment";
import { required } from "vuelidate/lib/validators";
import { formatCurrency } from "../helpers/format-currency";

import BudgetItemDialog from "./AppBudgetItemDialog";

export default {
  name: "budget-detail",
  components: {
    BudgetItemDialog,
  },
  data() {
    return {
      requestId: null,
      techReq: {},
      setTimeout: null,
      budgetItemDialog: false,
      selectedItem: null,
      selectedItemType: null,
      selectedItemIndex: null,
      currentBudget: {
        status_budget: {
          id: 1,
          name: "Nuevo",
        },
        request_technician: null,
        description: "",
        items_manpower: [],
        items_supplies: [],
      },
    };
  },
  validations() {
    const validations = {
      currentBudget: {
        description: { required },
      },
    };
    return validations;
  },
  created() {
    this.requestId = this.$route.query?.request_id;
    this.$store.commit("set_last_screen", "budget-detail");
    if (this.$store.state.current_budget.id)
      this.currentBudget = { ...this.$store.state.current_budget };
  },
  mounted() {
    this.$store.commit("set_app_title", this.dialogTitle);
    this.$store.dispatch("setCurrentTechnician", this.requestId);
    window.scrollTo(0, 0);
  },
  computed: {
    currentTechnician() {
      return this.$store.state.current_techReq;
    },
    isNewBudget: function () {
      if (!this.currentBudget.id) return true;
      return false;
    },
    dialogTitle: function () {
      if (this.currentBudget.id && !this.editBudgetDisabled) {
        return "Editar presupuesto #" + this.currentBudget.id;
      } else if (this.currentBudget.id && this.editBudgetDisabled) {
        return "Presupuesto #" + this.currentBudget.id;
      }
      return "Nuevo presupuesto";
    },
    manpowerTotalAmount: function () {
      let totalAmount = 0;
      this.currentBudget.items_manpower.forEach((item) => {
        totalAmount = totalAmount + Number(item.amount) * Number(item.cant);
      });
      return totalAmount;
    },
    suppliesTotalAmount: function () {
      let totalAmount = 0;
      this.currentBudget.items_supplies.forEach((item) => {
        totalAmount = totalAmount + Number(item.amount) * Number(item.cant);
      });
      return totalAmount;
    },
    budgetTotalAmount: function () {
      return this.manpowerTotalAmount + this.suppliesTotalAmount;
    },
    addItemsDisabled: function () {
      if (
        !this.currentBudget.id ||
        this.currentBudget.status_budget.id !== 1 ||
        this.$v.currentBudget.$error
      )
        return true;
      return false;
    },
    editBudgetDisabled: function () {
      if (this.currentBudget.status_budget.id !== 1) return true;
      return false;
    },
    editItemDisabled: function () {
      if (
        this.currentBudget.status_budget.id !== 1 ||
        this.$v.currentBudget.$error
      )
        return true;
      return false;
    },
    requestApprovalDisabled: function () {
      if (
        !this.currentBudget.id ||
        this.budgetTotalAmount === 0 ||
        this.$v.currentBudget.$error
      )
        return true;
      return false;
    },
    descriptionErrors: function () {
      const errors = [];
      if (!this.$v.currentBudget.description.$error) return errors;
      !this.$v.currentBudget.description.required &&
        errors.push("Este campo es requerido");
      return errors;
    },
    isVisitBudget() {
      const VISIT_BUDGET_TYPE = 13;
      return this.currentBudget
        ? this.currentBudget.tipo_presupuesto === VISIT_BUDGET_TYPE
        : false;
    },
    budgetStatusChipColor() {
      const DEFAULT_COLOR = "blue darken-2";
      const GREEN_COLOR = "green";
      const RED_COLOR = "red accent-2";
      const ORANGE_COLOR = "orange darken-1";

      const COLOR_MAP = {
        1: DEFAULT_COLOR,
        3: DEFAULT_COLOR,
        5: DEFAULT_COLOR,
        6: DEFAULT_COLOR,
        8: DEFAULT_COLOR,
        10: DEFAULT_COLOR,
        2: GREEN_COLOR,
        11: GREEN_COLOR,
        9: ORANGE_COLOR,
        4: RED_COLOR,
        7: RED_COLOR,
      };

      return COLOR_MAP[this.currentBudget?.status_budget?.id] || DEFAULT_COLOR;
    },
  },
  methods: {
    formatCurrency,

    showBudgetItemDialog(itemType, selectedItem, selectedItemIndex) {
      if (!this.editBudgetDisabled && !this.editItemDisabled) {
        selectedItem
          ? (this.selectedItem = selectedItem)
          : (this.selectedItem = { description: null, cant: 1, amount: null });
        this.selectedItemIndex = selectedItemIndex;
        this.selectedItemType = itemType;
        this.budgetItemDialog = true;
      }
    },
    deleteItem() {
      switch (this.selectedItemType) {
        case "manpower":
          this.currentBudget.items_manpower.splice(this.selectedItemIndex, 1);
          break;
        case "supplies":
          this.currentBudget.items_supplies.splice(this.selectedItemIndex, 1);
          break;
      }
      this.saveBudget();
    },
    saveItem(item) {
      if (!this.selectedItemIndex) {
        switch (this.selectedItemType) {
          case "manpower":
            this.currentBudget.items_manpower.push(item);
            break;
          case "supplies":
            this.currentBudget.items_supplies.push(item);
            break;
        }
      } else {
        switch (this.selectedItemType) {
          case "manpower":
            this.currentBudget.items_manpower[this.selectedItemIndex] = item;
            break;
          case "supplies":
            this.currentBudget.items_supplies[this.selectedItemIndex] = item;
            break;
        }
      }
      this.saveBudget();
    },
    saveBudget() {
      this.$v.currentBudget.$touch();

      if (!this.$v.currentBudget.$error) {
        if (!this.currentBudget.id) {
          if (!this.currentTechnician) return;
          this.currentBudget.request_technician = this.currentTechnician.id;

          this.axios
            .post(`/budget/`, this.currentBudget)
            .then((response) => {
              this.currentBudget = response.data;
              this.$store.commit(
                "show_alert",
                "Cambios guardados correctamente"
              );
              this.$store.commit("set_current_budget", this.currentBudget);
            })
            .catch((error) => {
              console.log({ error });
            });
        } else {
          this.axios
            .put(`/budget/${this.currentBudget.id}/`, this.currentBudget)
            .then((response) => {
              this.currentBudget = response.data;
              this.$store.commit(
                "show_alert",
                "Cambios guardados correctamente"
              );
              this.$store.commit("set_current_budget", this.currentBudget);
            })
            .catch((err) => {
              console.log({ err });
            });
        }
      }
    },
    requestApproval() {
      this.axios
        .post(`/budget/${this.currentBudget.id}/send/`, {})
        .then((response) => {
          Object.assign(
            this.currentBudget.status_budget,
            response.data.status_budget
          );
          this.$store.commit("show_alert", "Cambios guardados correctamente");
          this.$store.commit("set_current_budget", this.currentBudget);
        })
        .catch((err) => {
          console.log({ err });
        });
    },
    formatDate(date) {
      const _date = new Date();
      const today = moment(_date).format("YYYY-MM-DD");
      if (date === today) {
        return "Hoy";
      } else {
        return moment(date, "YYYY-MM-DD").format("dddd DD MMMM, YYYY");
      }
    },
  },
};
</script>
<style scoped>
@media (min-width: 960px) {
  .pull-right-on-desktop {
    display: flex;
    justify-content: flex-end;
  }
}
.bottom-bar {
  position: fixed;
  padding: 0 24px;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 88px;
  display: flex;
  justify-content: flex-end;
}
.pb24 {
  padding-bottom: 84px;
}
.pb0 {
  padding-bottom: 0;
}
.pt0 {
  padding-top: 0;
}
.p0 {
  padding: 0;
}
.m0 {
  margin: 0;
}
.date {
  text-transform: capitalize;
  text-align: left;
}
.status-name-cont {
  height: 30px;
  background: #c8272a;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-weight: bold;
  font-size: 12px;
  text-transform: capitalize;
}
</style>
